import React from 'react';

interface MobilePageWrapperProps {
  children: React.ReactNode;
  className?: string;
  enableSwipeNavigation?: boolean; // Keep for backwards compatibility but ignore
}

/**
 * Simplified page wrapper component
 * 
 * Previously contained complex swipe navigation logic that was unused.
 * Now just provides a simple container for page content.
 * 
 * @param children - Page content to wrap
 * @param className - Additional CSS classes
 * @param enableSwipeNavigation - Deprecated, kept for backwards compatibility
 */
export const MobilePageWrapper: React.FC<MobilePageWrapperProps> = ({
  children,
  className = '',
  enableSwipeNavigation = true // Ignored but kept for compatibility
}) => {
  return (
    <div className={`h-full w-full ${className}`}>
      {children}
    </div>
  );
};

export default MobilePageWrapper; 